var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientOnly',[_c('div',[_c('HeaderCommissionBalance'),_vm._v(" "),_c('HeaderDirectMessages',{staticClass:"mobile-header-warroom__direct-messages"}),_vm._v(" "),_c('HeaderMenuWinWire')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }